import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import cn from 'classnames';
import BackButton from '../../../components/BackButton/BackButton';
import { tabs } from '../constants/tabs';
import styles from '../Room.module.scss';

const path = '/Offices/facilities';

const RoomHeader = ({ room, onEditRoomClick }) => {
  const history = useHistory();
  const params = useParams();

  const userCanEdit = useSelector(
    (store) => store.authentication.userInfo.CanCreateOffice
  );

  const handleBackButtonClick = () =>
    history.push(`${path}/${params.facilityId}/rooms`);

  const handleTabBtnClick = (key) => {
    history.push(`${path}/${params.facilityId}/rooms/${params.roomId}/${key}`);
  };

  return (
    <div className={styles.header}>
      <BackButton onClick={handleBackButtonClick} />
      <div className={styles.address}>
        {room.name}{' '}
        <span className={styles.highlight}>
          {(room.rentalHouse?.name || room.floor || room.number) && '/ '}
          {room.rentalHouse?.name && `${room.rentalHouse?.name}, `}
          {room.floor && `${room.floor} этаж`}
          {room.number && `, пом. ${room.number}`}
        </span>
      </div>
      {userCanEdit && (
        <Button
          shape={'round'}
          className={styles.editRoom}
          onClick={onEditRoomClick}
        >
          Редактировать
        </Button>
      )}
      <div className={cn(styles.tabsContainer, styles.rightColumn)}>
        {tabs.map((tab) => (
          <Button
            className={cn(styles.tabButton, {
              [styles.active]: params.roomTab === tab.key,
            })}
            key={tab.key}
            onClick={
              params.roomTab === tab.key
                ? undefined
                : () => handleTabBtnClick(tab.key)
            }
          >
            {tab.tab}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default RoomHeader;
